const url = process.env.REACT_APP_URL

export default url